import projectDetailsEditComponent from './project-details-edit.component';

const projectDetailsEditModule = angular.module('projectDetailsEdit', [
])
  .component('projectDetailsEdit', projectDetailsEditComponent)
  .name;

export default projectDetailsEditModule;
